import { render } from "./iOrganization.vue?vue&type=template&id=2a6e77a6"
import script from "./iOrganization.vue?vue&type=script&lang=js"
export * from "./iOrganization.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__